import { defineStore } from "pinia";
import { ref } from "vue";
import type { Ref } from "vue";

export interface AlertMessage {
  text: string;
  title: string;
  type: AlertTypes;
  timer: number;
  id: number;
}
export enum AlertTypes {
  "success" = "success",
  "info" = "info",
  "warning" = "warning",
  "error" = "error",
}
export const useAlertStore = defineStore("alert", () => {
  const count = ref(0);
  const messages: Ref<AlertMessage[]> = ref([]);
  function error(text: string, title: string = "", timer = 8) {
    return add(AlertTypes.error, text, title, timer);
  }
  function info(text: string, title: string = "", timer = 8) {
    return add(AlertTypes.info, text, title, timer);
  }
  function warning(text: string, title: string = "", timer = 8) {
    return add(AlertTypes.warning, text, title, timer);
  }
  function success(text: string, title: string = "", timer = 8) {
    return add(AlertTypes.success, text, title, timer);
  }
  function add(type: AlertTypes, text: string, title: string = "", timer = 8) {
    count.value++;
    const message = {
      text,
      title,
      type,
      timer,
      id: count.value,
    };
    if (timer > 0) {
      setTimeout(() => {
        close(message.id);
      }, timer * 1000);
    }

    messages.value.push(message);
  }
  function close(id: number) {
    const index = messages.value.findIndex((message) => message.id === id);
    if (index !== -1) {
      messages.value.splice(index, 1);
    }
  }
  return {
    messages,
    success,
    info,
    warning,
    error,
  };
});
export default useAlertStore;
